// id is for specifiying that that row is an id of something and should be translated, like lot_type = 143 - used in exporting to excel.  boolean flag also will translate 1's and 0's into yes/no for human readable
export default [
	{ english: "Community", name: "property", id: "properties" },
	{ english: "Buyer ID", name: "buyer_id" },
	{ english: "Lot ID", name: "lot_id" },
	{ english: "Primary Last", name: "primary_last" },
	{ english: "Primary First", name: "primary_first" },
	{ english: "Primary Age", name: "primary_age" },
	{ english: "Primary Occupation", name: "primary_occupation", id: "occupations" },
	{ english: "Primary Employer", name: "primary_employer" },
	{ english: "Primary Ethnicity", name: "primary_ethnicity" },
	{ english: "Primary Email", name: "primary_email" },
	{ english: "Has Co", name: "has_co", boolean: true },
	{ english: "Co Last", name: "co_last" },
	{ english: "Co First", name: "co_first" },
	{ english: "Co Age", name: "co_age" },
	{ english: "Co Occupation", name: "co_occupation", id: "occupations" },
	{ english: "Co Employer", name: "co_employer" },
	{ english: "Co Ethnicity", name: "co_ethnicity" },
	{ english: "Co Email", name: "co_email" },
	{ english: "Buyer Address", name: "buyer_address" },
	{ english: "Buyer City", name: "buyer_city" },
	{ english: "Buyer State", name: "buyer_state" },
	{ english: "Buyer Zip", name: "buyer_zip" },
	{ english: "Buyer Country", name: "buyer_country" },
	{ english: "Buyer Phone", name: "buyer_phone" },
	{ english: "Realtor Involved", name: "realtor_involved", boolean: true },
	{ english: "Realtor Name", name: "realtor_name" },
	{ english: "Realtor Email", name: "realtor_email" },
	{ english: "Realtor Phone", name: "realtor_phone" },
	{ english: "Realtor Company", name: "realtor_company" },
	{ english: "Realtor Address", name: "realtor_address" },
	{ english: "Realtor Address2", name: "realtor_address2" },
	{ english: "Realtor City", name: "realtor_city" },
	{ english: "Realtor State", name: "realtor_state" },
	{ english: "Realtor Zip", name: "realtor_zip" },
	{ english: "Realtor License", name: "realtor_license" },
	{ english: "Realtor Office License", name: "realtor_office_license" },
	{ english: "Realtor Office Name", name: "realtor_office_name" },
	{ english: "First Time", name: "first_time", boolean: true },
	{ english: "Is Relo", name: "is_relo", boolean: true },
	{ english: "Is Moving Within", name: "is_moving_within", boolean: true },
	{ english: "Has Extended Fam", name: "has_extended_fam", boolean: true },
	{ english: "Has Family In", name: "has_family_in", boolean: true },
	{ english: "Num Residents", name: "num_residents" },
	{ english: "Has Children", name: "has_children", boolean: true },
	{ english: "Input Date", name: "addedDate" },
	{ english: "Purchase Reason", name: "purchase_reason" },
	{ english: "Other Communities Considered", name: "other_communities_considered" },
	{ english: "Source", name: "traffic_source" },
	{ english: "Referral", name: "referral" },
	{ english: "Model", name: "model", boolean: true },
	{ english: "Is Price Particiation", name: "is_price_participation", boolean: true },
	{ english: "Visited Info Ctr", name: "visited_infocenter" },
	{ english: "Community Counselor", name: "community_counselor" },
	{ english: "Lot Type", name: "lot_type", id: "lot_types" },
	{ english: "Lot Type", name: "lot_type_name" },
	{ english: "Sale Type", name: "sale_type" },
	{ english: "Section", name: "section_id", id: "sections" },
	{ english: "Section Name", name: "section_name" },
	{ english: "Block", name: "block" },
	{ english: "Lot", name: "lot" },
	{ english: "Neighborhood", name: "neighborhood", id: "neighborhoods" },
	{ english: "Address", name: "address" },
	{ english: "Builder", name: "builder", id: "builders" },
	{ english: "Salesperson", name: "salesperson", id: "salespeople" },
	{ english: "Sale ID", name: "sale_id" },
	{ english: "Sale Price", name: "sale_price" },
	{ english: "Sale Price", name: "price" },
	{ english: "Sale Date", name: "sale_date" },
	{ english: "Takedown Date", name: "takedown_date" },
	{ english: "Cancel Date", name: "bustout_date" },
	{ english: "Cancel Reason", name: "bustout_reason" },
	{ english: "Cancel Report Time", name: "bustout_report_time" },
	{ english: "Cancel Date", name: "cancel_date" },
	{ english: "Transfer Date", name: "transfer_date" },
	{ english: "Closing Date", name: "closing_date" },
	{ english: "Closing Price", name: "closing_price" },
	{ english: "Estimated Closing", name: "estimated_closing" },
	{ english: "Start Date", name: "start_date" },
	{ english: "Floorplan", name: "floorplan", id: "floorplans" },
	{ english: "Sq Ft", name: "sqft" },
	{ english: "Stories", name: "stories" },
	{ english: "Bedrooms", name: "beds" },
	{ english: "Full Baths", name: "full_baths" },
	{ english: "Half Baths", name: "half_baths" },
	{ english: "Garage", name: "garage" },
	{ english: "In Feed", name: "in_feed", boolean: true },
	{ english: "In Feed Manual", name: "in_feed_manual", boolean: true },
	{ english: "Is Promo", name: "is_promo", boolean: true },
	{ english: "Notice To Homebuyers Date", name: "document_notice" },
	{ english: "Notification Map Date", name: "document_notification" },
	{ english: "Rules & Regs Date", name: "document_rules" },
	{ english: "Buyer Profile Date", name: "document_profile" },
	{ english: "Buyer Profile", name: "buyer_profile" },
	{ english: "Resident Manual Date", name: "document_resident" },
	{ english: "Notes", name: "notes" },
	{ english: "Cancel Reason", name: "reason" },
	{ english: "Date", name: "date" },
	{ english: "Base Price", name: "base_price" },
	{ english: "Baths", name: "baths" },
	{ english: "ISD", name: "isd", id:"isds" },
	{ english: "LID", name: "lid", id: "lids" },
	{ english: "MUD", name: "mud", id: "muds" },
	{ english: "ID", name: "id" },
	{ english: "Lot Price", name: "lot_price" },
	{ english: "Community", name: "community", id: "properties" },
	{ english: "Contract Date", name: "contract_date" },
	//{ english: "Percent Lot", name: "percent_lot" },
	{ english: "Price Per Square Foot", name: "ppsqft" },
	{ english: "Section", name: "section" },
	{ english: "Site Type", name: "site_type", id: "sites" },
	{ english: "Site Type", name: "site_id", id: "sites" },
	{ english: "Closed Date", name: "closed_date" },
	{ english: "Subdivision", name: "sub" },
	{ english: "Date", name: "date" },
	{ english: "# Sold", name: "num_sold" },
	{ english: "Sales Value", name: "num_sales_value" },
	{ english: "Destination Address", name: "destination_address" },
	{ english: "Construction Status", name: "construction_status" },
]